import { EOrderStatus, IOrder } from '../../types/order'
import dayjs from 'dayjs'
import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'

interface Props {
  order: IOrder
}

const OverdueTag = (props: Props) => {
  const { order } = props
  const overdue = order?.status === EOrderStatus.TRACKING
  return (
    <>
      {overdue && (
        <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>
          <Tag color={`error`}>ค้างส่ง</Tag>
        </Box>
      )}
    </>
  )
}

export default OverdueTag
